import { jsx } from "react/jsx-runtime";
import React from "react";
var box_cancel_default = (prefix = "") => {
  return [/* @__PURE__ */ jsx("path", { d: "m14.0366 4.1885 5.9658 4.2934V13h-2V9.9942H6.0004l.0018 8.0001h6.9979v2H4.0027L4 8.482l5.9658-4.2935 1.1683 1.6233-3.0325 2.1824h7.7993l-3.0326-2.1824 1.1683-1.6233z" }), /* @__PURE__ */ jsx("path", { d: "m18.4528 19.8914 2.121 2.1211 1.4143-1.4142-2.1211-2.1211 2.1212-2.1212-1.4142-1.4142-2.1212 2.1212-2.1216-2.1216-1.4142 1.4142 2.1216 2.1216-2.1215 2.1214 1.4143 1.4142 2.1214-2.1214zM10.0029 14h4v-2h-4v2z" })];
};
export {
  box_cancel_default as default
};
